import {FullDrawerConfirmation} from '@stripe-internal/conversations-ui';

import {closeConfirmationMessages as messages} from '../../../core/messages';
import {
  useThreadsConfirmationActions,
  useThreadsPendingConfirmation,
} from '../../app/hooks';

export function ThreadsConfirmationModal() {
  const pendingConfirmation = useThreadsPendingConfirmation();
  const {confirmRestart, cancelRestart, confirmClose, cancelClose} =
    useThreadsConfirmationActions();

  if (pendingConfirmation?.type === 'restart') {
    return (
      <FullDrawerConfirmation
        open
        title={messages.title}
        description={messages.description}
        confirmLabel={messages.restartConfirm}
        cancelLabel={messages.cancel}
        onConfirm={confirmRestart}
        onCancel={cancelRestart}
      />
    );
  }

  if (pendingConfirmation?.type !== 'close') {
    return null;
  }

  return (
    <FullDrawerConfirmation
      open
      title={messages.title}
      description={messages.description}
      confirmLabel={messages.confirm}
      cancelLabel={messages.cancel}
      onConfirm={confirmClose}
      onCancel={cancelClose}
    />
  );
}
